// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lNACBw0t7oAtsrzzcOmA{flex-direction:column;gap:8px;display:flex}.JXct69hfdtQUSjt8RJRI{align-items:flex-start;gap:8px;display:flex}.JXct69hfdtQUSjt8RJRI .JZhW7hQVZMmR450uN4qX{flex:1;min-width:0}.JXct69hfdtQUSjt8RJRI .DL_nPXHSQh8sBaJNVQ_w{flex-shrink:0;margin-top:4px}.cyXC0XPfxXYV5eqqR8n0{justify-content:flex-start;margin-top:-8px;display:flex}.bPbUzhVbsc5JjVmrG4zo{width:-webkit-fit-content;width:fit-content}.phErtrfOA4Af7TXzhmBI{background:var(--background-neutral-subtle);border-radius:8px;flex-direction:column;align-self:stretch;align-items:flex-start;margin-top:12px;padding:22px 20px 20px;display:flex}.t6AfUClr6MH0BzKvKVzG{white-space:pre-wrap;word-break:break-all;width:100%;margin:0}.j05saSc1_jod5Dx2ayCR{width:100%;margin-top:16px}.j05saSc1_jod5Dx2ayCR>div{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"domainList": `lNACBw0t7oAtsrzzcOmA`,
	"domainRow": `JXct69hfdtQUSjt8RJRI`,
	"domainInput": `JZhW7hQVZMmR450uN4qX`,
	"deleteButton": `DL_nPXHSQh8sBaJNVQ_w`,
	"addButtonWrap": `cyXC0XPfxXYV5eqqR8n0`,
	"addButton": `bPbUzhVbsc5JjVmrG4zo`,
	"bottomBlock": `phErtrfOA4Af7TXzhmBI`,
	"scriptPreview": `t6AfUClr6MH0BzKvKVzG`,
	"copyButtonWrap": `j05saSc1_jod5Dx2ayCR`
};
export default ___CSS_LOADER_EXPORT___;
